module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2015/mobile.svg?v=10d48cae";